module.exports = __webpack_public_path__ + "static/KC8-4548ba8391832f868204be5ea6685869.png";